import httpAuth from '../../services/httpAuth'
import httpNotAuth from '../../services/httpNotAuth'
import getErrorMessage from '../../helpers/getErrorMessage.helper'
import { getRacingPageDataSuccess, getRacingPageError } from './racingPage.slice'
// import {getAccountStatementError, getAccountStatementSuccess} from './accountStatement.slice'

export const requestRacingPageData = (data) => async (dispatch, getState) => {
  const checkAuth = getState().auth

  if(checkAuth) {

    if (data?.sport_id === "7" || data?.sport_id === "4339") {
      try {
        const response = await httpAuth.post(`/market/allRacingMarkets`, data);

        if (response?.data?.status) {
          let res = response?.data?.data;
          dispatch(getRacingPageDataSuccess(res));
          // const menu = await response.data.result.filter((item, index, self) =>
          //   index === self.findIndex((t) => t.id === item.id)
          // )
        } else {
          dispatch(getRacingPageDataSuccess([]));
          dispatch(getRacingPageError());
        }
        return response;
      } catch (e) {
        dispatch(getRacingPageError());
        //  const errorMsg = getErrorMessage(e)
        //  throw errorMsg
      }
    }
  } else {
    try {
      const response = await httpNotAuth.post(
        `/market/allRacingMarketsOpen`,
        data
      );

      if (response?.data?.status) {
        let res = response?.data?.data;
        dispatch(getRacingPageDataSuccess(res));
        // const menu = await response.data.result.filter((item, index, self) =>
        //   index === self.findIndex((t) => t.id === item.id)
        // )
      } else {
        dispatch(getRacingPageDataSuccess([]));
        dispatch(getRacingPageError());
      }
      return response;
    } catch (e) {
      dispatch(getRacingPageError());
      //  const errorMsg = getErrorMessage(e)
      //  throw errorMsg
    }
  }
}
